import stageKey from "Utils/stageKey";

const DAY = 86400000;
const CLOSED = ["OPTED_OUT", "BOUNCED", "CUSTOMER", "DO_NOT_CONTACT"];

const contactDetailFindings = ({
  activeSequences = [],
  lastActivityType = "",
  lastActivityTs = 0,
  openTasks = 0,
  stage = "",
  now = Date.now(),
  meetingBooked = false,
  emailBounced = false,
  researchReady = false,
  tab = "",
  actions = {}
} = {}) => {
  const out = [];
  // The contact APIs return display-cased stages ("Not Contacted", "Bounced"),
  // not the SCREAMING_SNAKE constants, so compare on a normalized form.
  const key = stageKey(stage);
  const seqs = activeSequences || [];
  if (seqs.length > 1) {
    out.push({
      tone: "warn",
      key: "multi_sequence",
      label: `In ${seqs.length} active sequences`,
      text: `${seqs.map(s => s.name).join(", ")} will all email them. Keep one.`
    });
  }
  const replied = lastActivityType === "REPLY";
  if (replied && seqs.length) {
    seqs.forEach(s =>
      out.push({
        tone: "warn",
        key: "replied_enrolled",
        label: `Replied, still in ${s.name}`,
        text: "Automated steps after a reply read as spam. Complete them in the sequence.",
        actions: actions.completeIn ? [{ label: "Complete in sequence", run: () => actions.completeIn(s) }] : []
      })
    );
  }
  if (replied && !openTasks) {
    out.push({
      tone: "hot",
      key: "replied_no_task",
      label: "Replied, no follow-up task",
      text: "Book the next touch while it is warm.",
      actions: actions.createTask ? [{ label: "Create task", run: actions.createTask }] : []
    });
  }
  const quietDays = lastActivityTs ? Math.floor((now - lastActivityTs) / DAY) : 0;
  if (!seqs.length && quietDays >= 30 && !CLOSED.includes(key)) {
    out.push({
      tone: "neutral",
      key: "quiet",
      label: `Quiet for ${quietDays} days`,
      text: "No touch in a month and not in a sequence. Re-engage or close them out.",
      actions: actions.addToSequence ? [{ label: "Add to sequence", run: actions.addToSequence }] : []
    });
  }
  if (meetingBooked && !openTasks) {
    out.push({
      tone: "hot",
      key: "meeting_follow_up",
      label: "Meeting booked, no follow-up",
      text: "Create the prep and follow-up tasks now, while it is on the calendar.",
      actions: actions.createTask ? [{ label: "Create task", run: actions.createTask }] : []
    });
  }
  if (emailBounced || key === "BOUNCED") {
    out.push({
      tone: "bad",
      key: "bounced_email",
      label: "Email bounced",
      text: "Nothing you send will land. Find a new address.",
      actions: actions.findNewEmail ? [{ label: "Find a new email", run: actions.findNewEmail }] : []
    });
  }
  if (researchReady && tab === "deepresearch") {
    out.push({
      tone: "hot",
      key: "research_ready",
      label: "Research is ready",
      text: "Turn it into an opener or a three-step sequence.",
      actions: [
        ...(actions.draftOpener ? [{ label: "Draft opener", run: actions.draftOpener }] : []),
        ...(actions.buildSequence ? [{ label: "Build a sequence", run: actions.buildSequence }] : [])
      ]
    });
  }
  return out;
};

export default contactDetailFindings;
